/**
 * fancyboxGallery Component
 *
 * @file slider.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


const fancyboxGallery = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const defaultFancybox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
    }); 
    Fancybox.bind('[data-fancybox="home-video-gallery"]', {
      // Custom options for all galleries
      Thumbs:false
    }); 
    $('.cookie-accept').on('click', function(){
      Fancybox.close();
    });  
  };

  // const balloonModal = () => {
  //   var e = document.getElementsByClassName("svg-map-hr")
  //     , t = document.querySelector(".map-balloon");
  //   for (let i = 0; i < e.length; i += 1) {
  //     e[i].addEventListener("mouseover", function(e) {
  //         if (e.target.getAttribute("data-value") === "1"){
  //           if (e.target.getAttribute("data-box2") !== null){
  //             t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box") + e.target.getAttribute("data-box2"), "</div>"].join("");
  //           }  else{
  //             t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box"), "</div>"].join("");
  //           }
  //         } else{
  //           t.innerHTML = ""
  //         }
  //     });
  //     e[i].addEventListener("mousemove", function(e) {
  //         var t = $(this).parent().offset(),
  //         mouse_x = e.pageX - t.left + 50 + "px",
  //         mouse_y = e.pageY - t.top + -150 + "px",
  //         mouse_x = mouse_x,
  //         mouse_y = mouse_y;
  //         $(".map-balloon").css({
  //             left: mouse_x,
  //             top: mouse_y
  //         });
  //     }),
  //     e[i].addEventListener("mouseout", function(e) {
  //         t.innerHTML = ""
  //     });
  //   }
  // };
  const balloonModal = () => {
    var e = document.getElementsByClassName("svg-map-hr")
      , t = document.querySelector(".map-balloon");
    for (let i = 0; i < e.length; i += 1) {
      e[i].addEventListener("click", function(e) {
        if(e.target.getAttribute("data-href") != null){
          window.open(e.target.getAttribute("data-href"), "_self");
        }
      });
      e[i].addEventListener("mouseover", function(e) {
        // alert("asd");
      });
      
      if($(".dmt-tab-content-v2").is(':visible')) {
        e[i].addEventListener("mouseover", function(e) {
            if (e.target.getAttribute("data-value") === "1"){
              if (e.target.getAttribute("data-box2") !== null){
                $(this).parents(".home-map-tab-content").find(".map-balloon").html('<div class="map-box-item">'+ e.target.getAttribute("data-box") + e.target.getAttribute("data-box2")+ "</div>");
              }  else{
                $(this).parents(".home-map-tab-content").find(".map-balloon").html('<div class="map-box-item">'+ e.target.getAttribute("data-box")+ "</div>");
              }
            } else{
              $(".map-balloon").html("");
            }
        });
      } else{
        e[i].addEventListener("mouseover", function(e) {
            if (e.target.getAttribute("data-value") === "1"){
              if (e.target.getAttribute("data-box2") !== null){
                  t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box") + e.target.getAttribute("data-box2"), "</div>"].join("");
              }  else{
                t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box"), "</div>"].join("");
              }
            } else{
              t.innerHTML = ""
            }
        });
      }


      e[i].addEventListener("mousemove", function(e) {
          var t = $(this).parent().offset(),
          mouse_x = e.pageX - t.left + 50 + "px",
          mouse_y = e.pageY - t.top + -150 + "px",
          mouse_x = mouse_x,
          mouse_y = mouse_y;
          $(".map-balloon").css({
              left: mouse_x,
              top: mouse_y
          });
      }),
      e[i].addEventListener("mouseout", function(e) {
          t.innerHTML = ""
      });
    }
  };


  const customSelect = () => {
    // var x, i, j, l, ll, selElmnt, a, b, c;
    // /*look for any elements with the class "custom-select":*/
    // x = document.getElementsByClassName("custom-select");
    // l = x.length;
    // for (i = 0; i < l; i++) {
    //   selElmnt = x[i].getElementsByTagName("select")[0];
    //   ll = selElmnt.length;
    //   /*for each element, create a new DIV that will act as the selected item:*/
    //   a = document.createElement("DIV");
    //   a.setAttribute("class", "select-selected");
    //   a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    //   x[i].appendChild(a);
    //   /*for each element, create a new DIV that will contain the option list:*/
    //   b = document.createElement("DIV");
    //   b.setAttribute("class", "select-items select-hide");
    //   for (j = 1; j < ll; j++) {
    //     /*for each option in the original select element,
    //     create a new DIV that will act as an option item:*/
    //     c = document.createElement("DIV");
    //     c.innerHTML = selElmnt.options[j].innerHTML;
    //     c.addEventListener("click", function(e) {
    //         /*when an item is clicked, update the original select box,
    //         and the selected item:*/
    //         var y, i, k, s, h, sl, yl;
    //         s = this.parentNode.parentNode.getElementsByTagName("select")[0];
    //         sl = s.length;
    //         h = this.parentNode.previousSibling;
    //         for (i = 0; i < sl; i++) {
    //           if (s.options[i].innerHTML == this.innerHTML) {
    //             console.log(s.options[i].value)
    //             s.selectedIndex = i;
    //             h.innerHTML = this.innerHTML;
    //             y = this.parentNode.getElementsByClassName("same-as-selected");
    //             yl = y.length;
    //             for (k = 0; k < yl; k++) {
    //               y[k].removeAttribute("class");
    //             }
    //             this.setAttribute("class", "same-as-selected");
    //             break;
    //           }
    //         }
    //         h.click();
    //     });
    //     b.appendChild(c);
    //   }
    //   x[i].appendChild(b);
    //   a.addEventListener("click", function(e) {
    //       /*when the select box is clicked, close any other select boxes,
    //       and open/close the current select box:*/
    //       e.stopPropagation();
    //       closeAllSelect(this);
    //       this.nextSibling.classList.toggle("select-hide");
    //       this.classList.toggle("select-arrow-active");
    //     });
    // }
    // function closeAllSelect(elmnt) {
    //   /*a function that will close all select boxes in the document,
    //   except the current select box:*/
    //   var x, y, i, xl, yl, arrNo = [];
    //   x = document.getElementsByClassName("select-items");
    //   y = document.getElementsByClassName("select-selected");
    //   xl = x.length;
    //   yl = y.length;
    //   for (i = 0; i < yl; i++) {
    //     if (elmnt == y[i]) {
    //       arrNo.push(i)
    //     } else {
    //       y[i].classList.remove("select-arrow-active");
    //     }
    //   }
    //   for (i = 0; i < xl; i++) {
    //     if (arrNo.indexOf(i)) {
    //       x[i].classList.add("select-hide");
    //     }
    //   }
    // }
    // /*if the user clicks anywhere outside the select box,
    // then close all select boxes:*/
    // document.addEventListener("click", closeAllSelect);
  };

  const customSelect2 = () => {
    $(".chSelect").change(function () {
      if($(this).val() == "0") $(this).addClass("empty");
      else $(this).removeClass("empty")
    });
    $(".chSelect").change();
  };

  const init = () => {
    defaultFancybox();
    balloonModal();
    customSelect();
    customSelect2();
  };

  return {
    init,
  };
})();

export default fancyboxGallery;